

import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "terminales",
  data() {
    return {
      loading: false,
      result_upload: 555,
      message_err: "Aqui se visualizará el resultado de la importación.",
      tarea: ""
    };
  },
  computed: {},
  mounted: function() {
    $(".box").boxWidget();
  },

  methods: {
    subir_txt() {
      this.result_upload = 555;
      this.message_err = "Aqui se visualizará el resultado de la importación.";
      this.tarea = "";

      var formData = new FormData();
      var imagefile = document.querySelector("#file");
      formData.append("file", imagefile.files[0]);
      formData.append("a", "sidef");

      if (imagefile.files[0] != undefined) {
        this.loading = true;
        this.$http
          .post("SERVER/scd/configs/", formData, {
            withCredentials: true,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            this.result_upload = response.data.status;

            if (response.data.status == 1) {
              this.message_err =
                "Archivo cargado correctamente, se importaron: " +
                response.data.ok +
                " registros, errores al importar: " +
                response.data.err;

              if (response.data.r2.status == 1) {
                this.tarea =
                  "Debido a que este proceso lleva algo de tiempo, le enviaremos una notificación cuando este finalizado";
                this.showNotification({
                  msj: "Archivo importado",
                  bg: "bg-green"
                });
              } else {
                this.message_err =
                  "Si bien el archivo se importo, ocurrió algún problema al crear la tarea automática. Contacto con soporte.";
                this.showNotification({
                  msj: this.message_err,
                  bg: "bg-yellow"
                });
              }
            } else if (response.data.status == 4) {
              this.message_err = "EL tamaño del archivo supera el permitido.";
              this.showNotification({
                msj: this.message_err,
                bg: "bg-yellow"
              });
            } else if (response.data.status == 5) {
              this.message_err = "Solo se permiten archivos de texto plano.";

              this.showNotification({
                msj: this.message_err,
                bg: "bg-yellow"
              });
            } else if (response.data.status == 6) {
              this.message_err =
                "No se pudo encontrar el numero de liquidación en el nombre del archivo. Puede contactar con soporte para mas información.";
              this.showNotification({
                msj: this.message_err,
                bg: "bg-yellow"
              });
            } else {
              this.message_err =
                "Ocurrió un error al procesar el archivo, si este error persiste, contacte con soporte.";
              this.showNotification({
                msj: this.message_err,
                bg: "bg-red"
              });
            }

            this.loading = false;
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.showNotification({
              msj: "Error inesperado del servidor. Contacte con soporte.",
              bg: "bg-red"
            });
          });
      } else {
        this.showNotification({
          msj: "Verifique que el archivo se encuentre cargado.",
          bg: "bg-yellow"
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/configs/sidecreer/main/index.js